const NEXT_DEFAULT_TRANSLATION_KEY = 'PUBLIC_BOOKING.CHECK_ITEMS.NEXT_BTN';
const stepNavigation = {
    controller(bbWidgetStep, BBWidget) {
        'ngInject';

        this.currentStep = BBWidget.current_step;
        this.loadPreviousStep = bbWidgetStep.loadPreviousStep;
        this.nextTranslationKey = this.nextTranslationKey || NEXT_DEFAULT_TRANSLATION_KEY;
    },
    template: require('./step-navigation.component.html').template,
    bindings: {
        onNext: '&',
        nextTranslationKey: '@',
        isDisabled: '<',
        hideSelectButton: '@'
    }
};

export default stepNavigation;





// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/step-navigation/step-navigation.component.js